var Marionette = require('marionette'),
	$ = require('jquery');

module.exports = Marionette.ItemView.extend( {
    template: require('./template.hbs'),
    serializeData: function() {
        return {
            side: this.side
        };
    },
    onRender: function() {
        Backbone.View.prototype.unwrap.call(this);
        /* Put in the sub view */
        this.$('[data-content]').append( this.panelTemplate() );
        this.bindUIElements();
    },
    onShow: function() {
        /* Now changing the parent of el -- layout positioning applied to region -- todo: should be mediated atop */
        this.$parent = this.$el.parent(); /* caching for perf */
    },
    toggleOpen: function(pane) { //called from toggleOfMain (change: isOpen): updates position to width, then open/closes
        this.updatePosition(pane, pane.get('width'));
        return this.$parent.toggleClass('open').promise();
    },
    updatePosition: function(pane, widthValue) { //called from a change in width property of the model
        this.$parent.css({
            width: widthValue,
            right: parseFloat(widthValue)  * -1
        });
    },
    toggleSubPane: function(model) {
        var currentSubPane = model.get('currentSubPane'),
            previousSubPane = model.previous('currentSubPane');
        $.when(this.$parent.removeClass(previousSubPane).addClass(currentSubPane)).then( function() {
            model.trigger('panel:postToggleSubPane', model);
        });
     },
    onBeforeDestroy: function() {
       this.$parent.remove();
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelCommon/paneViewBase.js
 ** module id = 746
 ** module chunks = 0
 **/